import { createSlice } from "@reduxjs/toolkit";
import {
  registerUserAsync,
  loginUserAsync,
  verifyEmailAsync,
  updateProfileAsync,
  getProfileAysnc,
  forgotPasswordAysnc,
  resetPasswordAysnc,
  updateBusinessPagesAysnc,
  getAllRestaurantsAysnc,
  GoogleSearchAysnc,
  GoogleSearchNearByAddressAysnc,
  getMyBusinessAysnc,
  getSingleBusinessAysnc,
  editBusinessAysnc,
  editRequestAysnc,
  resendVerifyEmailAsync,
  googleTokenAsync,
  getGoogleReviewAysnc,
  getFacebookReviewAysnc,
  getYelpReviewAysnc,
  getTwitterReviewAysnc,
  scrapeUrlAsync,
  scrapeAllAsync,
  updateAllAsync,
  removeBusinessAsync,
  deleteAccountAsync,
  updateSrappingAsync,
  facebookTokenAsync,
  getFbDataAsync,
  getRequestReviewAysnc,
  reviewRequestByLink,
  getRequestReviewCountAysnc,
  getGenericReviewRequestAysnc,
  genericReviewRequestByLink,
  googleLoginUserAsync,
  checkGoogleBusinessOwnership,
  checkFacebookBusinessOwnership,
  updateBusinessAddressAsync,
  chatbotCompareMeAsync,
  chatbotRAmomentssSggestionAsync,
  getContactAsync,
  getMomentAsync,
  getOfferAsync,
  getRequestReviewListAsync,
  getReviewRequestByIdAsync,
  editReviewRequestByIdAsync,
  getReviewRequestByIdCrmAsync,
  fetchUserAsync
} from "../../actions/auth";


const initialState = {
  status: "idle",
  registerData: {},
  loginData: {},
  verifyEmail: null,
  updateProfile: {},
  getprofile: {},
  authLoading: false,
  loading: false,
  error: null,
  forgotPassword: {},
  resetPassword: {},
  updateBusinessPages: {},
  getAllRestaurants: [],
  googleAddress: {},
  addressBasedOnLatLong: {},
  myBusinessList: [],
  requestReviewList: [],
  requestGenericRequest: [],
  reviewRequestGenric: {},
  requestReviewStats: [],
  getSingleBusiness: {},
  addNewBusiness: {},
  editBusiness: {},
  editRequestData : {},
  resendVerifyEmail: {},
  getGoogleToken: {},
  getFacebookData: {},
  getYelpData: {},
  getTwitterData: {},
  getScrapeUrl: {},
  dashboardFalse: false,
  dashboardFalse1: false,
  scrapeAllAsync: {},
  getScrapeUpdatedData: {},
  removeBusiness: {},
  deleteAccount: {},
  updateSrapping: {},
  fbToken: {},
  getScrapeFbData: {},
  reviewRequestLink: [],
  checkGoogleOwnership:{},
  checkFacebookOwnership:{},
  updateBusinessAddress: {},
  compareMe:{},
  RAMoments:{},
  MomentData:{},
  offerData:{},
  requestReviewListData:{},
  reviewRequestByIDData:{},
  editReviewRequestByIDData:{},
  getReviewRequestByIdCRM:{},
  fetchUserData:{}
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearResetPasswordState: (state) => {
      state.resetPassword = {};
    },
    clearRegister: (state) => {
      state.registerData = {};
    },
    clearUpdateProfile: (state) => {
      state.getprofile = {};
    },
    clearGoogleAddress: (state) => {
      state.googleAddress = {};
    },
    clearAddressBasedOnLatLong: (state) => {
      state.addressBasedOnLatLong = {};
    },
    clearAddNewBusiness: (state) => {
      state.addNewBusiness = {};
    },
    clearFacebookReview: (state) => {
      state.getFacebookData = {};
    },
    clearEditBusiness: (state) => {
      state.editBusiness = {};
    },
    dashboardPage: (state, action) => {
      state.dashboardFalse = action.payload;
    },
    dashboardPage1: (state, action) => {
      state.dashboardFalse1 = true;
    },

    clearDashoardPage: (state) => {
      state.dashboardFalse = false;
    },
    resetGetScrapeUrl: (state) => {
      state.getScrapeUrl = {};
    },

    resetAuthSync: (state) => {
      state.getGoogleToken = {};
    },
    resetFBscrapedData: (state) => {
      state.getScrapeFbData = {};
    },
    clearFbTokenState: (state) => {
      state.fbToken = {}
    }
  },
  extraReducers: (builder) => {
    builder
      // register api cases
      .addCase(registerUserAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(registerUserAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.registerData = action.payload;
      })
      .addCase(registerUserAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      // login api cases
      .addCase(loginUserAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(loginUserAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.loginData = action.payload;
      })
      .addCase(loginUserAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = action.payload; // Store the entire error information
      })

       // google login api cases
       .addCase(googleLoginUserAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(googleLoginUserAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.loginData = action.payload;
      })
      .addCase(googleLoginUserAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = action.payload; // Store the entire error information
      })

      // verify email api cases
      .addCase(verifyEmailAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(verifyEmailAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.verifyEmail = action.payload;
      })
      .addCase(verifyEmailAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(resendVerifyEmailAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(resendVerifyEmailAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.resendVerifyEmail = action.payload;
      })
      .addCase(resendVerifyEmailAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      // update profile api cases
      .addCase(updateProfileAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(updateProfileAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.updateProfile = action.payload;
      })
      .addCase(updateProfileAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      // get profile api cases
      .addCase(getProfileAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getProfileAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.getprofile = action.payload;
      })
      .addCase(getProfileAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(deleteAccountAsync.pending, (state) => {
        state.loading = true;
        state.status = "idle";
      })
      .addCase(deleteAccountAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.loading = false;
        state.deleteAccount = action.payload;
      })
      .addCase(deleteAccountAsync.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.error = "invalid credential";
      })

      // forgot password
      .addCase(forgotPasswordAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(forgotPasswordAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.forgotPassword = action.payload;
      })
      .addCase(forgotPasswordAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      // reset password
      .addCase(resetPasswordAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(resetPasswordAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.resetPassword = action.payload;
      })
      .addCase(resetPasswordAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      // update Business media links
      .addCase(updateBusinessPagesAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(updateBusinessPagesAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.updateBusinessPages = action.payload;
      })
      .addCase(updateBusinessPagesAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(getAllRestaurantsAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getAllRestaurantsAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.getAllRestaurants = action.payload;
      })
      .addCase(getAllRestaurantsAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(GoogleSearchAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(GoogleSearchAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.googleAddress = action.payload;
      })
      .addCase(GoogleSearchAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(GoogleSearchNearByAddressAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(GoogleSearchNearByAddressAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.addressBasedOnLatLong = action.payload;
      })
      .addCase(GoogleSearchNearByAddressAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(getGoogleReviewAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getGoogleReviewAysnc.fulfilled, (state, action) => {
        state.status = "201";
        state.authLoading = false;
        state.addNewBusiness = action.payload;
      })
      .addCase(getGoogleReviewAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(getYelpReviewAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getYelpReviewAysnc.fulfilled, (state, action) => {
        state.status = "201";
        state.authLoading = false;
        state.getYelpData = action.payload;
      })
      .addCase(getYelpReviewAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(getTwitterReviewAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getTwitterReviewAysnc.fulfilled, (state, action) => {
        state.status = "201";
        state.authLoading = false;
        state.getTwitterData = action.payload;
      })
      .addCase(getTwitterReviewAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      .addCase(getFacebookReviewAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getFacebookReviewAysnc.fulfilled, (state, action) => {
        state.status = "201";
        state.authLoading = false;
        state.getFacebookData = action.payload;
      })
      .addCase(getFacebookReviewAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(scrapeUrlAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(scrapeUrlAsync.fulfilled, (state, action) => {
        state.status = "201";
        state.authLoading = false;
        state.getScrapeUrl = action.payload;
      })
      .addCase(scrapeUrlAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(scrapeAllAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(scrapeAllAsync.fulfilled, (state, action) => {
        state.status = "201";
        state.authLoading = false;
        state.getScrapeData = action.payload;
      })
      .addCase(scrapeAllAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(updateSrappingAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(updateSrappingAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.updateSrapping = action.payload;
      })
      .addCase(updateSrappingAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(updateAllAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(updateAllAsync.fulfilled, (state, action) => {
        state.status = "201";
        state.authLoading = false;
        state.getScrapeUpdatedData = action.payload;
      })
      .addCase(updateAllAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(getMyBusinessAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getMyBusinessAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.myBusinessList = action.payload;
      })
      .addCase(getRequestReviewAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.requestReviewList = action.payload;
      })
      .addCase(getGenericReviewRequestAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.requestGenericRequest = action.payload;
      })
      .addCase(genericReviewRequestByLink.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.reviewRequestGenric = action.payload;
      })
      .addCase(getRequestReviewCountAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.requestReviewStats = action.payload;
      })
      .addCase(getMyBusinessAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(getSingleBusinessAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getSingleBusinessAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.getSingleBusiness = action.payload;
      })
      .addCase(getSingleBusinessAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(editBusinessAysnc.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(editBusinessAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.editBusiness = action.payload;
      })
      .addCase(editBusinessAysnc.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      .addCase(editRequestAysnc.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.editRequestData = action.payload;
      })
      .addCase(googleTokenAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(googleTokenAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.getGoogleToken = action.payload;
      })
      .addCase(googleTokenAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(removeBusinessAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(removeBusinessAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.removeBusiness = action.payload;
      })
      .addCase(removeBusinessAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      .addCase(facebookTokenAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(facebookTokenAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.fbToken = action.payload;
      })
      .addCase(facebookTokenAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      .addCase(getFbDataAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getFbDataAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.getScrapeFbData = action.payload;
      })
      .addCase(getFbDataAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

      .addCase(reviewRequestByLink.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.reviewRequestLink = action.payload;
      })
      .addCase(checkGoogleBusinessOwnership.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.checkGoogleOwnership = action.payload;
      })
      .addCase(checkFacebookBusinessOwnership.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.checkFacebookOwnership = action.payload;  
      })
      // update business address links
      .addCase(updateBusinessAddressAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(updateBusinessAddressAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.updateBusinessAddress = action.payload;
      })
      .addCase(updateBusinessAddressAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
//conpare me
       .addCase(chatbotCompareMeAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(chatbotCompareMeAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.compareMe = action.payload;
      })
      .addCase(chatbotCompareMeAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      //RA Momemts
       .addCase(chatbotRAmomentssSggestionAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(chatbotRAmomentssSggestionAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.RAMoments = action.payload;
      })
      .addCase(chatbotRAmomentssSggestionAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })

//Tavlo Momemt 
      .addCase(getMomentAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getMomentAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.MomentData = action.payload;
      })
      .addCase(getMomentAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
  //Tavlo Offer 
      .addCase(getOfferAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getOfferAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.offerData = action.payload;
      })
      .addCase(getOfferAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      //Tavlo Request Review List
      .addCase(getRequestReviewListAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getRequestReviewListAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.requestReviewListData = action.payload;
      })
      .addCase(getRequestReviewListAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
 //Tavlo 
       .addCase(getReviewRequestByIdAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getReviewRequestByIdAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.reviewRequestByIDData = action.payload;
      })
      .addCase(getReviewRequestByIdAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      //Tavlo 
       .addCase(editReviewRequestByIdAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(editReviewRequestByIdAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.editReviewRequestByIDData = action.payload;
      })
      .addCase(editReviewRequestByIdAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
// getReviewRequestByIdCrm
      .addCase(getReviewRequestByIdCrmAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(getReviewRequestByIdCrmAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.getReviewRequestByIdCRM = action.payload;
      })
      .addCase(getReviewRequestByIdCrmAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      })
      // fetchUser
       .addCase(fetchUserAsync.pending, (state) => {
        state.authLoading = true;
        state.status = "idle";
      })
      .addCase(fetchUserAsync.fulfilled, (state, action) => {
        state.status = "200";
        state.authLoading = false;
        state.fetchUserData = action.payload;
      })
      .addCase(fetchUserAsync.rejected, (state, action) => {
        state.status = "idle";
        state.authLoading = false;
        state.error = "invalid credential";
      });
  },
});
export const {
  clearResetPasswordState,
  clearUpdateProfile,
  clearGoogleAddress,
  clearAddNewBusiness,
  clearFacebookReview,
  clearAddressBasedOnLatLong,
  clearEditBusiness,
  clearRegister,
  dashboardPage,
  clearDashoardPage,
  dashboardPage1,
  resetGetScrapeUrl,
  resetAuthSync,
  resetFBscrapedData,
  clearFbTokenState
} = authSlice.actions;
export default authSlice.reducer;
